import { motion } from "framer-motion";

export const TypingIndicator = () => {
  return (
    <div className="flex justify-start mb-2 px-3">
      <div
        className="bg-muted/60 backdrop-blur-xl rounded-2xl rounded-bl-md px-4 py-3 flex items-center gap-1"
        style={{
          boxShadow: "0 2px 12px hsl(var(--foreground) / 0.06), inset 0 1px 0 hsl(0 0% 100% / 0.3)",
        }}
      >
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="w-2 h-2 rounded-full bg-muted-foreground/60"
            animate={{ y: [0, -5, 0] }}
            transition={{
              duration: 0.6,
              repeat: Infinity,
              delay: i * 0.15,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>
    </div>
  );
};
